module.exports = "https://static.wanderu.com/ui-react/_next/static/media/left-black-arrow.35ad3a8f.svg";